import React, { useState } from "react";
import {
  Typography,
  Box,
  TextField,
  FormControl,
  Select,
  MenuItem,
  Button,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import {
  AccordionDetailsStyled,
  AccordionStyled,
  AccordionSummaryStyled,
} from "app/pages/components/mui/Accordions/StyledAccordion/StyleAccordion";
import BulkUpdateDialog from "../../../../components/BulkUpdateDialog";

const DifficultiesAccordion = ({
  expanded,
  onChange,
  problemDifficulties,
  handleDifficultyChange,
  handleDeleteDifficulty,
  handleAddDifficulty,
  difficulties,
  setProblemData,
}) => {
  const [openDialog, setOpenDialog] = useState(false);

  const validateDifficulties = (parsedDifficulties) => {
    parsedDifficulties.forEach((difficulty, index) => {
      if (!difficulty.count || !difficulty.difficulty) {
        throw new Error(
          `Difficulty at index ${index} is missing count or difficulty`
        );
      }
    });
  };

  const handleBulkUpdateDifficulties = (parsedDifficulties) => {
    setProblemData((prev) => {
      const updatedDifficulties = parsedDifficulties.map((difficulty) => ({
        difficulty: difficulty.difficulty,
        count: difficulty.count,
      }));
      return {
        ...prev,
        problemDifficulties:
          updatedDifficulties.length > 0 ? updatedDifficulties : null,
      };
    });
  };
  return (
    <>
      <AccordionStyled expanded={expanded} onChange={onChange}>
        <AccordionSummaryStyled
          expandIcon={<ExpandMoreIcon />}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Typography variant="subtitle1" sx={{ alignSelf: "center" }}>
            Difficulties
          </Typography>
          {expanded && (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Button
                variant="outlined"
                startIcon={<AddIcon />}
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenDialog(true);
                }}
              >
                Bulk Update
              </Button>
              <IconButton
                color="#475259"
                aria-label="Add Difficulty"
                onClick={handleAddDifficulty}
                disabled={!expanded}
              >
                <AddIcon />
              </IconButton>
            </Box>
          )}
        </AccordionSummaryStyled>
        <AccordionDetailsStyled>
          {problemDifficulties && problemDifficulties.length > 0 ? (
            problemDifficulties.map((difficulty, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  gap: 2,
                  mb: 2,
                  justifyContent: "space-between",
                }}
              >
                <Box sx={{ display: "flex", gap: 2 }}>
                  <TextField
                    type="number"
                    label="Count"
                    value={difficulty.count || ""}
                    onChange={(e) =>
                      handleDifficultyChange(index, "count", e.target.value)
                    }
                  />
                  <FormControl sx={{ minWidth: "200px" }}>
                    <Select
                      value={difficulty.difficulty || ""}
                      onChange={(e) =>
                        handleDifficultyChange(
                          index,
                          "difficulty",
                          e.target.value
                        )
                      }
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select Difficulty
                      </MenuItem>
                      {difficulties.map((d) => (
                        <MenuItem key={d.key} value={d.key}>
                          {d.value}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
                <IconButton
                  color="error"
                  aria-label="Delete Difficulty"
                  onClick={() => handleDeleteDifficulty(index)}
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            ))
          ) : (
            <Typography>No difficulties available</Typography>
          )}
        </AccordionDetailsStyled>
      </AccordionStyled>

      <BulkUpdateDialog
        title="Bulk Update Difficulties"
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onBulkUpdate={handleBulkUpdateDifficulties}
        validateInput={validateDifficulties}
        successMessage="Difficulties added successfully!"
        helperText="Enter an array of difficulties in JSON format (e.g., [{ 'count': 1, 'difficulty': 'Easy' }])"
      />
    </>
  );
};

export default DifficultiesAccordion;
